{
  "verified": "2026-10-13",
  "sourcesNote": "Deadlines and caps checked against Nolo's state charts (updated 2026) and statute text; penalties checked against statute text or court and legal-aid summaries of it. South Dakota (SL 2026 ch. 179) and Colorado (HB25-1249) reflect 2025-2026 changes.",
  "states": [
    {
      "name": "Alabama", "abbr": "AL", "slug": "alabama",
      "citation": "Ala. Code § 35-9A-201",
      "deadlineDays": 60,
      "deadline": "60 days after the tenancy ends and you hand back possession.",
      "cap": "One month's rent, with exceptions for pet deposits, deposits to cover undoing alterations, and activities that raise the landlord's liability risk.",
      "penalty": "If the landlord sends neither the refund nor an itemized accounting within the 60 days, they owe you double the original deposit.",
      "penaltyShort": "2x deposit",
      "notes": ["A deposit left unclaimed for 90 days is forfeited, so keep your forwarding address current."]
    },
    {
      "name": "Alaska", "abbr": "AK", "slug": "alaska",
      "citation": "Alaska Stat. §§ 34.03.070, 34.03.120",
      "deadlineDays": 14,
      "deadline": "14 days if you gave proper notice to end the tenancy. 30 days if you didn't, or if the landlord deducted for damage caused by failing to maintain the unit.",
      "cap": "Two months' rent, unless rent is over $2,000 a month. An extra month's rent is allowed as a pet deposit (not for service animals), usable only for pet damage.",
      "penalty": "If the landlord willfully fails to refund or itemize, a court can award up to twice the amount withheld.",
      "penaltyShort": "up to 2x withheld"
    },
    {
      "name": "Arizona", "abbr": "AZ", "slug": "arizona",
      "citation": "Ariz. Rev. Stat. § 33-1321",
      "deadlineDays": 14, "businessDays": true,
      "deadline": "14 days, not counting Saturdays, Sundays or legal holidays. You also have the right to be present at the move-out inspection.",
      "cap": "One and a half months' rent.",
      "penalty": "If the landlord doesn't follow the itemization rules, you can recover the money owed plus damages equal to twice the amount wrongfully withheld.",
      "penaltyShort": "withheld + 2x"
    },
    {
      "name": "Arkansas", "abbr": "AR", "slug": "arkansas",
      "citation": "Ark. Code §§ 18-16-301 to 18-16-306",
      "deadlineDays": 60,
      "deadline": "60 days after the tenancy ends and you deliver possession, with a written itemized list for anything kept.",
      "cap": "Two months' rent. The cap, deadline and penalty don't apply to landlords who own five or fewer units and manage them themselves.",
      "penalty": "A landlord who misses the rules can owe the money plus up to twice the amount wrongfully withheld, and attorney's fees. A genuine good-faith dispute or honest error limits this to the amount itself.",
      "penaltyShort": "up to 2x withheld"
    },
    {
      "name": "California", "abbr": "CA", "slug": "california",
      "citation": "Cal. Civ. Code § 1950.5",
      "deadlineDays": 21,
      "deadline": "21 days after you move out, with an itemized statement. Repairs and cleaning over $125 need receipts or invoices.",
      "cap": "One month's rent for most landlords. Small landlords (individuals or all-individual LLCs owning no more than two properties with four units total) can take two months. Active service members can only be charged one month.",
      "penalty": "If the landlord keeps the deposit in bad faith, a court can award up to twice the deposit as a penalty, on top of actual damages.",
      "penaltyShort": "up to 2x deposit + damages"
    },
    {
      "name": "Colorado", "abbr": "CO", "slug": "colorado",
      "citation": "Colo. Rev. Stat. §§ 38-12-102 to 38-12-106",
      "deadlineDays": 30,
      "deadline": "30 days after the lease ends or you surrender the unit, whichever is later. The lease can extend this to no more than 60 days.",
      "cap": "Two months' rent, plus a refundable pet deposit of up to $300.",
      "penalty": "Wrongful withholding makes the landlord liable for three times the amount withheld, plus attorney's fees and court costs. You must give the landlord at least 7 days' written notice that you intend to sue.",
      "penaltyShort": "3x withheld",
      "notes": ["Colorado's 2025 law (HB25-1249) put the burden on the landlord to prove the withholding wasn't wrongful."]
    },
    {
      "name": "Connecticut", "abbr": "CT", "slug": "connecticut",
      "citation": "Conn. Gen. Stat. § 47a-21",
      "deadlineDays": 21,
      "deadline": "21 days after the tenancy ends, or 15 days after the landlord gets your written forwarding address, whichever is later. Interest is owed on top.",
      "cap": "Two months' rent, or one month's rent if you are 62 or older.",
      "penalty": "A landlord who breaks the return rules owes twice the deposit.",
      "penaltyShort": "2x deposit"
    },
    {
      "name": "Delaware", "abbr": "DE", "slug": "delaware",
      "citation": "Del. Code tit. 25, §§ 5311, 5514",
      "deadlineDays": 20,
      "deadline": "20 days after the lease ends, with an itemized list of damages and estimated repair costs for anything kept.",
      "cap": "One month's rent on leases of a year or more. No cap for furnished units.",
      "penalty": "If the landlord misses the 20 days, you're entitled to double the amount wrongfully withheld.",
      "penaltyShort": "2x withheld"
    },
    {
      "name": "District of Columbia", "abbr": "DC", "slug": "district-of-columbia",
      "citation": "D.C. Code § 42-3502.17; 14 DCMR §§ 308-311",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends to return the deposit with interest, or to tell you in writing that some of it will be kept.",
      "cap": "One month's rent, plus a pet deposit of up to 15% of monthly rent.",
      "penalty": "Missing the deadline creates a presumption that you're owed the full deposit. Bad-faith withholding is punishable by treble damages.",
      "penaltyShort": "3x if bad faith"
    },
    {
      "name": "Florida", "abbr": "FL", "slug": "florida",
      "citation": "Fla. Stat. §§ 83.49, 83.491",
      "deadlineDays": 15,
      "deadline": "15 days if the landlord makes no claim. To keep any of it, they must send a written notice of claim by certified mail within 30 days. You then have 15 days to object.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who misses the 30-day notice forfeits the right to make any claim on the deposit. The winner of a deposit dispute in court can recover attorney's fees.",
      "penaltyShort": "forfeits claim + fees"
    },
    {
      "name": "Georgia", "abbr": "GA", "slug": "georgia",
      "citation": "Ga. Code §§ 44-7-30 to 44-7-37",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends.",
      "cap": "Two months' rent.",
      "penalty": "A landlord who improperly keeps part of the deposit owes three times that amount plus reasonable attorney's fees, unless they prove it was an honest mistake.",
      "penaltyShort": "3x withheld + fees"
    },
    {
      "name": "Hawaii", "abbr": "HI", "slug": "hawaii",
      "citation": "Haw. Rev. Stat. § 521-44",
      "deadlineDays": 14,
      "deadline": "14 days after the rental agreement ends, with a written statement of anything kept.",
      "cap": "One month's rent.",
      "penalty": "A landlord who misses the 14-day notice loses the right to keep any of the deposit. Wrongful and willful retention can lead to damages of three times the amount kept.",
      "penaltyShort": "3x if willful",
      "notes": ["You have one year after the tenancy ends to sue over the deposit."]
    },
    {
      "name": "Idaho", "abbr": "ID", "slug": "idaho",
      "citation": "Idaho Code §§ 6-320, 6-321",
      "deadlineDays": 21,
      "deadline": "21 days, or up to 30 days if you and the landlord agreed to that in writing.",
      "cap": "No statutory cap.",
      "penalty": "You can sue for the deposit plus court costs. Idaho Legal Aid notes a judge can award up to three times the deposit when the landlord didn't follow the rules.",
      "penaltyShort": "up to 3x (court's call)"
    },
    {
      "name": "Illinois", "abbr": "IL", "slug": "illinois",
      "citation": "765 Ill. Comp. Stat. 710/1",
      "deadlineDays": 30,
      "deadline": "30 days to send an itemized statement with receipts if anything is kept. With no proper statement, the full deposit is due within 45 days of move-out. The Act covers buildings with five or more units.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who doesn't follow the Act owes twice the deposit, plus court costs and attorney's fees.",
      "penaltyShort": "2x deposit + fees",
      "notes": ["Chicago has its own ordinance (the RLTO) with separate rules on top of state law."]
    },
    {
      "name": "Indiana", "abbr": "IN", "slug": "indiana",
      "citation": "Ind. Code §§ 32-31-3-12 to 32-31-3-16",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends and you return the unit. You must give the landlord your mailing address in writing.",
      "cap": "No statutory cap.",
      "penalty": "No itemized notice in time counts as agreeing that no damages are due, so the full deposit must be returned. The landlord also owes your attorney's fees and court costs.",
      "penaltyShort": "full deposit + fees"
    },
    {
      "name": "Iowa", "abbr": "IA", "slug": "iowa",
      "citation": "Iowa Code § 562A.12",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, once you've given a forwarding address.",
      "cap": "Two months' rent.",
      "penalty": "Bad-faith retention can bring punitive damages of up to twice the monthly rent, plus actual damages. Courts may award attorney's fees to the winner.",
      "penaltyShort": "up to 2 months' rent"
    },
    {
      "name": "Kansas", "abbr": "KS", "slug": "kansas",
      "citation": "Kan. Stat. §§ 58-2548, 58-2550",
      "deadlineDays": 30,
      "deadline": "14 days after the landlord works out the deductions, and no later than 30 days after the tenancy ends.",
      "cap": "One month's rent unfurnished, one and a half months furnished, plus half a month for pets.",
      "penalty": "You can recover the amount due plus damages of one and a half times the amount wrongfully withheld.",
      "penaltyShort": "withheld + 1.5x"
    },
    {
      "name": "Kentucky", "abbr": "KY", "slug": "kentucky",
      "citation": "Ky. Rev. Stat. § 383.580",
      "deadlineDays": null,
      "deadline": "Between 30 and 60 days, depending on whether you dispute the deductions. The statute only applies in cities and counties that adopted the Uniform Residential Landlord and Tenant Act.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who doesn't follow the rules loses the right to keep any part of the deposit. Kentucky doesn't multiply the amount.",
      "penaltyShort": "forfeits deposit"
    },
    {
      "name": "Louisiana", "abbr": "LA", "slug": "louisiana",
      "citation": "La. Rev. Stat. §§ 9:3251 to 9:3253",
      "deadlineDays": 30,
      "deadline": "One month after the lease ends, with an itemized statement.",
      "cap": "No statutory cap.",
      "penalty": "If the landlord doesn't pay within 30 days of your written demand, you can recover the amount wrongfully kept plus $300 or twice that amount, whichever is greater. Courts can also award attorney's fees.",
      "penaltyShort": "$300 or 2x, whichever is more"
    },
    {
      "name": "Maine", "abbr": "ME", "slug": "maine",
      "citation": "Me. Rev. Stat. tit. 14, §§ 6033, 6034",
      "deadlineDays": 30,
      "deadline": "30 days with a written lease, 21 days for a tenancy at will.",
      "cap": "Two months' rent.",
      "penalty": "Wrongful retention makes the landlord liable for twice the amount withheld, plus attorney's fees and costs. Give 7 days' notice before suing; if they don't pay in that time, wrongful retention is presumed.",
      "penaltyShort": "2x withheld + fees"
    },
    {
      "name": "Maryland", "abbr": "MD", "slug": "maryland",
      "citation": "Md. Code Real Prop. §§ 8-203, 8-203.1",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends.",
      "cap": "One month's rent for most leases signed from October 2024 on.",
      "penalty": "If the landlord withholds without a reasonable basis, you can sue for up to three times the amount withheld plus reasonable attorney's fees.",
      "penaltyShort": "up to 3x + fees"
    },
    {
      "name": "Massachusetts", "abbr": "MA", "slug": "massachusetts",
      "citation": "Mass. Gen. Laws ch. 186, § 15B",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends.",
      "cap": "One month's rent.",
      "penalty": "Missing the 30 days (or failing to keep the deposit in a separate account) means three times the deposit, plus 5% interest, court costs and attorney's fees.",
      "penaltyShort": "3x deposit + fees"
    },
    {
      "name": "Michigan", "abbr": "MI", "slug": "michigan",
      "citation": "Mich. Comp. Laws §§ 554.602 to 554.616",
      "deadlineDays": 30,
      "deadline": "30 days after you move out to mail an itemized list of damages. Give your forwarding address in writing within 4 days of moving out.",
      "cap": "One and a half months' rent.",
      "penalty": "No itemized list in 30 days means the landlord is treated as agreeing no damages are due and must return the full deposit. A landlord who doesn't fully comply can owe double the deposit kept.",
      "penaltyShort": "2x deposit kept"
    },
    {
      "name": "Minnesota", "abbr": "MN", "slug": "minnesota",
      "citation": "Minn. Stat. § 504B.178",
      "deadlineDays": 21,
      "deadline": "3 weeks after the tenancy ends and the landlord has your forwarding address. 5 days if the building was condemned through no fault of yours.",
      "cap": "No statutory cap.",
      "penalty": "You can recover the amount wrongfully withheld plus a penalty equal to that amount and interest. Bad-faith retention can add up to $500 in punitive damages.",
      "penaltyShort": "2x withheld (+ $500 if bad faith)"
    },
    {
      "name": "Mississippi", "abbr": "MS", "slug": "mississippi",
      "citation": "Miss. Code § 89-8-21",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends, you hand back possession, and you ask for the deposit.",
      "cap": "No statutory cap.",
      "penalty": "Bad-faith retention can add up to $200 in damages on top of actual damages.",
      "penaltyShort": "+ up to $200 if bad faith"
    },
    {
      "name": "Missouri", "abbr": "MO", "slug": "missouri",
      "citation": "Mo. Rev. Stat. § 535.300",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, with an itemized list of damages for anything kept.",
      "cap": "Two months' rent.",
      "penalty": "Wrongful withholding can cost the landlord up to twice the amount wrongfully withheld.",
      "penaltyShort": "up to 2x withheld"
    },
    {
      "name": "Montana", "abbr": "MT", "slug": "montana",
      "citation": "Mont. Code §§ 70-25-101 to 70-25-206",
      "deadlineDays": 30,
      "deadline": "30 days, or 10 days if there are no deductions.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who doesn't give a written list of charges loses the right to keep any of the deposit. If you sue, you recover the amount wrongfully withheld, and the court may award attorney's fees.",
      "penaltyShort": "amount withheld + fees"
    },
    {
      "name": "Nebraska", "abbr": "NE", "slug": "nebraska",
      "citation": "Neb. Rev. Stat. § 76-1416",
      "deadlineDays": 14,
      "deadline": "14 days after the tenancy ends, with a written itemization.",
      "cap": "One month's rent, or 1.25 months with a pet.",
      "penalty": "You can recover the money withheld, court costs and attorney's fees. If the failure was willful and not in good faith, add liquidated damages of one month's rent or twice the deposit, whichever is less.",
      "penaltyShort": "up to 1 month's rent extra"
    },
    {
      "name": "Nevada", "abbr": "NV", "slug": "nevada",
      "citation": "Nev. Rev. Stat. §§ 118A.240 to 118A.250",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends.",
      "cap": "Three months' rent.",
      "penalty": "A court can order the deposit returned plus an extra amount of up to the full deposit, depending on whether the landlord acted in good faith.",
      "penaltyShort": "up to 2x total"
    },
    {
      "name": "New Hampshire", "abbr": "NH", "slug": "new-hampshire",
      "citation": "N.H. Rev. Stat. §§ 540-A:5 to 540-A:8",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends.",
      "cap": "One month's rent or $100, whichever is greater.",
      "penalty": "A landlord who fails to return the deposit owes twice the deposit plus interest, minus lawful charges like unpaid rent or damage.",
      "penaltyShort": "2x net deposit"
    },
    {
      "name": "New Jersey", "abbr": "NJ", "slug": "new-jersey",
      "citation": "N.J. Stat. § 46:8-21.1",
      "deadlineDays": 30,
      "deadline": "30 days after the lease ends. 5 days if you had to leave because of fire, flood, condemnation or evacuation.",
      "cap": "One and a half months' rent.",
      "penalty": "Courts must award double the amount wrongfully withheld, plus costs. Attorney's fees are up to the court.",
      "penaltyShort": "2x withheld (mandatory)"
    },
    {
      "name": "New Mexico", "abbr": "NM", "slug": "new-mexico",
      "citation": "N.M. Stat. § 47-8-18",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, with a written statement of deductions.",
      "cap": "One month's rent for agreements under a year. No cap for leases of a year or more.",
      "penalty": "Missing the 30 days costs the landlord the right to keep any of the deposit, and makes them liable for your court costs and attorney's fees. Bad-faith retention adds a $250 civil penalty.",
      "penaltyShort": "forfeit + fees + $250"
    },
    {
      "name": "New York", "abbr": "NY", "slug": "new-york",
      "citation": "N.Y. Gen. Oblig. Law §§ 7-103 to 7-108",
      "deadlineDays": 14,
      "deadline": "14 days after you move out, with an itemized statement for anything kept.",
      "cap": "One month's rent.",
      "penalty": "Missing the 14 days forfeits the landlord's right to keep any of the deposit. A willful violation can bring punitive damages of up to twice the deposit.",
      "penaltyShort": "forfeit + up to 2x"
    },
    {
      "name": "North Carolina", "abbr": "NC", "slug": "north-carolina",
      "citation": "N.C. Gen. Stat. §§ 42-50 to 42-56",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends. If the claim can't be finalized in time, an interim accounting is due then and a final one within 60 days.",
      "cap": "Two weeks' rent for week-to-week, one and a half months for month-to-month, two months for longer terms.",
      "penalty": "Willful noncompliance voids the landlord's right to keep any of the deposit, and the court may award attorney's fees. You can also recover actual damages.",
      "penaltyShort": "forfeit + fees"
    },
    {
      "name": "North Dakota", "abbr": "ND", "slug": "north-dakota",
      "citation": "N.D. Cent. Code § 47-16-07.1",
      "deadlineDays": 30,
      "deadline": "30 days after the lease ends and you hand back possession.",
      "cap": "One month's rent, with higher limits for pets and some applicants.",
      "penalty": "A landlord who keeps deposit money without reasonable justification owes three times the amount wrongfully withheld.",
      "penaltyShort": "3x withheld"
    },
    {
      "name": "Ohio", "abbr": "OH", "slug": "ohio",
      "citation": "Ohio Rev. Code § 5321.16",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, with an itemized list for anything kept.",
      "cap": "No statutory cap.",
      "penalty": "You can recover the money due plus damages equal to the amount wrongfully withheld (so double in total) and reasonable attorney's fees. This only applies if you gave the landlord a forwarding address in writing.",
      "penaltyShort": "2x withheld + fees"
    },
    {
      "name": "Oklahoma", "abbr": "OK", "slug": "oklahoma",
      "citation": "Okla. Stat. tit. 41, § 115",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends, you deliver possession and you make a written demand. If you don't demand it within six months, the landlord can keep it.",
      "cap": "No statutory cap.",
      "penalty": "You can sue for the amount wrongfully withheld. Check the statute for any added damages before quoting a multiple.",
      "penaltyShort": "amount withheld"
    },
    {
      "name": "Oregon", "abbr": "OR", "slug": "oregon",
      "citation": "Or. Rev. Stat. § 90.300",
      "deadlineDays": 31,
      "deadline": "31 days after the tenancy ends and you deliver possession.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who fails to comply can owe twice the amount wrongfully withheld.",
      "penaltyShort": "2x withheld"
    },
    {
      "name": "Pennsylvania", "abbr": "PA", "slug": "pennsylvania",
      "citation": "68 Pa. Stat. §§ 250.511a to 250.512",
      "deadlineDays": 30,
      "deadline": "30 days after the lease ends or you surrender the unit, with a written list of damages for anything kept.",
      "cap": "Two months' rent in the first year, one month after that.",
      "penalty": "No written list in 30 days forfeits the landlord's right to withhold. Failing to pay what's owed within the 30 days makes them liable for double the amount. You must give a forwarding address in writing.",
      "penaltyShort": "forfeit + 2x"
    },
    {
      "name": "Rhode Island", "abbr": "RI", "slug": "rhode-island",
      "citation": "R.I. Gen. Laws § 34-18-19",
      "deadlineDays": 20,
      "deadline": "20 days after the latest of: the tenancy ending, you delivering possession, or you giving a forwarding address.",
      "cap": "One month's rent.",
      "penalty": "You can recover the amount owed plus damages of twice the amount wrongfully withheld, and reasonable attorney's fees.",
      "penaltyShort": "withheld + 2x + fees"
    },
    {
      "name": "South Carolina", "abbr": "SC", "slug": "south-carolina",
      "citation": "S.C. Code § 27-40-410",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, you deliver possession and you ask for the deposit, whichever is later.",
      "cap": "No statutory cap.",
      "penalty": "Willful failure to return the deposit with the required notice can cost the landlord three times the amount wrongfully withheld, plus attorney's fees.",
      "penaltyShort": "3x withheld + fees"
    },
    {
      "name": "South Dakota", "abbr": "SD", "slug": "south-dakota",
      "citation": "S.D. Codified Laws §§ 43-32-6.1, 43-32-24",
      "deadlineDays": 21,
      "deadline": "21 days after the tenancy ends and the landlord receives your mailing address (changed from two weeks in 2026). You can ask for a written itemized accounting within 45 days.",
      "cap": "One month's rent, unless special conditions justify more.",
      "penalty": "Bad-faith retention, or bad-faith failure to give the statement, can bring punitive damages of up to $200.",
      "penaltyShort": "+ up to $200 if bad faith"
    },
    {
      "name": "Tennessee", "abbr": "TN", "slug": "tennessee",
      "citation": "Tenn. Code § 66-28-301",
      "deadlineDays": null,
      "deadline": "No fixed number of days. The landlord must notify you at your last known address of the refund due; if you don't respond within 60 days, they may keep it. The statute only applies in larger counties covered by Tennessee's landlord-tenant act.",
      "cap": "No statutory cap.",
      "penalty": "A landlord who skips the required steps can lose the right to keep any of the deposit. Tennessee doesn't set double or triple damages.",
      "penaltyShort": "may forfeit deposit"
    },
    {
      "name": "Texas", "abbr": "TX", "slug": "texas",
      "citation": "Tex. Prop. Code §§ 92.101 to 92.113",
      "deadlineDays": 30,
      "deadline": "30 days after you surrender the unit. The landlord doesn't have to refund until you give a forwarding address in writing.",
      "cap": "No statutory cap.",
      "penalty": "Bad-faith retention costs the landlord $100, plus three times the amount wrongfully withheld, plus your attorney's fees. Missing the 30 days means bad faith is presumed.",
      "penaltyShort": "$100 + 3x + fees"
    },
    {
      "name": "Utah", "abbr": "UT", "slug": "utah",
      "citation": "Utah Code §§ 57-17-1 to 57-17-5",
      "deadlineDays": 30,
      "deadline": "30 days after the tenancy ends, or 15 days after receiving your forwarding address, whichever is later.",
      "cap": "No statutory cap.",
      "penalty": "If the landlord misses the deadline after you serve the required notice, you can recover the full deposit plus a $100 civil penalty. Attorney's fees are awarded if the other side acted in bad faith.",
      "penaltyShort": "full deposit + $100"
    },
    {
      "name": "Vermont", "abbr": "VT", "slug": "vermont",
      "citation": "Vt. Stat. tit. 9, § 4461",
      "deadlineDays": 14,
      "deadline": "14 days, or 60 days for a seasonal rental that wasn't your primary home.",
      "cap": "No statutory cap.",
      "penalty": "Missing the 14 days forfeits the right to keep any of it. If the failure was willful, the landlord owes double the amount wrongfully withheld, plus attorney's fees and costs.",
      "penaltyShort": "forfeit + 2x if willful"
    },
    {
      "name": "Virginia", "abbr": "VA", "slug": "virginia",
      "citation": "Va. Code § 55.1-1226",
      "deadlineDays": 45,
      "deadline": "45 days after the tenancy ends or you move out, whichever is later.",
      "cap": "Two months' rent.",
      "penalty": "If the landlord willfully fails to comply, the court orders the deposit returned with actual damages and reasonable attorney's fees.",
      "penaltyShort": "deposit + damages + fees"
    },
    {
      "name": "Washington", "abbr": "WA", "slug": "washington",
      "citation": "Wash. Rev. Code §§ 59.18.260 to 59.18.285",
      "deadlineDays": 30,
      "deadline": "30 days after the rental agreement ends and you vacate.",
      "cap": "No statutory cap, but tenants can pay the deposit in installments in many cases.",
      "penalty": "A landlord who intentionally refuses to give the statement or refund can be ordered to pay up to twice the deposit.",
      "penaltyShort": "up to 2x deposit"
    },
    {
      "name": "West Virginia", "abbr": "WV", "slug": "west-virginia",
      "citation": "W. Va. Code §§ 37-6A-1 to 37-6A-6",
      "deadlineDays": 60,
      "deadline": "60 days after the tenancy ends, or 45 days after a new tenant moves in, whichever is sooner.",
      "cap": "No statutory cap.",
      "penalty": "If the landlord's noncompliance was willful or not in good faith, you can recover the deposit plus damages of one and a half times the amount wrongfully withheld.",
      "penaltyShort": "withheld + 1.5x"
    },
    {
      "name": "Wisconsin", "abbr": "WI", "slug": "wisconsin",
      "citation": "Wis. Stat. § 704.28; Wis. Admin. Code ATCP 134.06",
      "deadlineDays": 21,
      "deadline": "21 days after the tenancy ends, with an itemized statement for anything kept.",
      "cap": "No statutory cap.",
      "penalty": "Under Wis. Stat. § 100.20(5), a tenant who loses money through a violation can recover twice the loss, plus costs and attorney's fees.",
      "penaltyShort": "2x loss + fees"
    },
    {
      "name": "Wyoming", "abbr": "WY", "slug": "wyoming",
      "citation": "Wyo. Stat. §§ 1-21-1207, 1-21-1208",
      "deadlineDays": 30,
      "deadline": "30 days after the rental agreement ends, or 15 days after receiving your forwarding address, whichever is later. Another 30 days is allowed for damage deductions.",
      "cap": "No statutory cap.",
      "penalty": "You can sue for the money owed if the landlord unreasonably fails to follow the law. Check the statute before quoting any multiple.",
      "penaltyShort": "amount owed"
    }
  ]
}
